import { GlobalStyles } from "@mui/material";

function JoyrideGlobalZIndex() {
  return (
    <GlobalStyles
      styles={{
        ".react-joyride__overlay": {
          zIndex: "2000 !important",
        },
        ".react-joyride__spotlight": {
          zIndex: "2100 !important",
        },
        ".react-joyride__tooltip": {
          zIndex: "2200 !important",
        },
      }}
    />
  );
}

export default JoyrideGlobalZIndex;
